// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__3EEkH","error":"Textarea_error__1ZQxQ","readonly":"Textarea_readonly__tSBlR","disabled":"Textarea_disabled__3zv-x"};